import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotifierService } from 'angular-notifier';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { SignatureConfigService } from 'src/app/core/services/signature-config.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { SignatureConfig } from 'src/app/shared/models/signature-config.model';
import { ErrorCode } from '../../../../../../../core/constants/error-code';

@Component({
  selector: 'app-dialog-signature-config',
  templateUrl: './dialog-signature-config.component.html',
  styleUrls: ['./dialog-signature-config.component.scss'],
})
export class DialogSignatureConfigComponent
  extends BaseComponent
  implements OnInit {
  mainFormGroup: FormGroup;

  dataSource: SignatureConfig;

  displayedColumns: string[] = [
    'stt',
    'page',
    'isMainSignature',
    'frameWidth',
    'frameHeight',
  ];

  listObject = [
    {name: 'Người dùng phê duyệt bên lập', code: 'ENTERPRISEAPPROVER'},
    {name: 'Người dùng ký duyệt bên lập', code: 'ENTERPRISE'},
    {name: 'Khách hàng', code: 'CUSTOMER'},
    {name: 'Người dùng phê duyệt bên khách hàng', code: 'CUSTOMERAPPROVER'},
  ];

  elms = <HTMLCollectionOf<HTMLInputElement>> (
    document.getElementsByClassName('check_box')
  );

  checkboxList: boolean[] = [];

  error: boolean = false;
  isNotAttestedUser: boolean = false;

  data = [];

  constructor(
    private dialog: MatDialogRef<DialogSignatureConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    public matDialog: MatDialog,
    public toastr: ToastrService,
    public signatureConfigService: SignatureConfigService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnInit() {
    if(this.isNotAttestedUser){
     this.listObject = [
        {name: 'Người dùng phê duyệt bên lập', code: 'ENTERPRISEAPPROVER'},
        {name: 'Người dùng ký duyệt bên lập', code: 'ENTERPRISE'},
        {name: 'Khách hàng', code: 'CUSTOMER'},
        {name: 'Người dùng phê duyệt bên khách hàng', code: 'CUSTOMERAPPROVER'},
      ];
    }
    else {
      this.listObject = [
        {name: 'Người dùng phê duyệt bên lập', code: 'ENTERPRISEAPPROVER'},
        {name: 'Người dùng ký duyệt bên lập', code: 'ENTERPRISE'},
        {name: 'Khách hàng', code: 'CUSTOMER'},
      ];
    }
    this.dataSource = this.dataDialog.data;
    this.initForm();
  }

  initForm() {
    this.mainFormGroup = new FormGroup({
      name: new FormControl(this.dataSource.name),
      object: new FormControl(
        this.dataSource.object ? this.dataSource.object : null,
        Validators.required
      ),
      prop: new FormArray([]),
    });

    if (this.dataSource.positions.length) {
      this.dataSource.positions.forEach((item) => {
        let temp = new FormGroup({
          main: new FormControl(item.main),
          width: new FormControl(item.width, Validators.required),
          height: new FormControl(item.height, Validators.required),
          signaturePositionId: new FormControl(item.signaturePositionId),
          page: new FormControl(item.page),
        });
        this.listProp.push(temp);
      });
    }

    for (let i = 0; i < this.listProp.value.length; i++) {
      this.checkboxList.push(this.listProp.value[i].main);
    }

    this.data = this.listProp.value;
  }

  get listProp() {
    return this.mainFormGroup.get('prop') as FormArray;
  }

  cancel() {
    if (this.mainFormGroup.dirty) {
      const dialog = this.matDialog.open(WarningComponent, {
        data: this.message.getMessage('messages.config_is_change'),
        width: '40%',
      });
      dialog.afterClosed().subscribe((ref) => {
        if (!ref) {
          return;
        }
        this.dialog.close();
      });
    } else {
      this.dialog.close();
    }
  }

  submitForm() {
    this.checkError();
    if (!this.error) {
      setTimeout(() => {
        this.dataSource.object = this.mainFormGroup.controls.object.value
          ? this.mainFormGroup.controls.object.value
          : null;
        this.dataSource.positions = this.listProp.value;

        this.signatureConfigService
          .saveSignature(this.dataSource.templateId, [this.dataSource])
          .subscribe((res) => {
            if (res.code === ErrorCode.NotPermissionTemplate) {
              this.toastr.error(
                this.message.getMessage('messages.check_permission')
              );
            }
            if (res && res.data) {
              this.toastr.success(
                this.message.getMessage('messages.update_signature_success')
              );
              this.dialog.close(true);
            }
          });
      });
    }
  }

  checkError() {
    this.error = false;
    if (!this.mainFormGroup.controls.object.value) {
      this.mainFormGroup.controls.object.setErrors({required: true});
      this.error = true;
      return;
    }
    if (
      this.mainFormGroup.controls.object.value &&
      this.mainFormGroup.controls.object.value === this.dataDialog.hasEnterprise
    ) {
      this.toastr.error(this.message.getMessage('messages.limit_enterprise'));
      this.error = true;
      return;
    }

    if (
      this.mainFormGroup.controls.object.value &&
      this.mainFormGroup.controls.object.value === 'ENTERPRISEAPPROVER' && this.dataDialog.checkApprover
    ) {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.limit_approver'), this.dataDialog.approverNumber));
      this.error = true;
      return;
    }

    let hasMain: boolean = false;
    for (let i = 0; i < this.listProp.value.length; i++) {
      if (!this.listProp.value[i].width) {
        this.toastr.error(this.message.getMessage('messages.width_required'));
        this.error = true;
        break;
      }
      if (!this.listProp.value[i].height) {
        this.toastr.error(this.message.getMessage('messages.height_required'));
        this.error = true;
        break;
      }

      if (this.listProp.value[i].main) {
        hasMain = true;
      }
    }

    if (!hasMain) {
      this.elms.item(0).classList.add('mat-checkbox-checked');
      this.listProp.value[0].main = true;
    }
  }

  toggle(event, index: number) {
    if (event.checked == true) {
      this.checkboxList[index] = true;
      this.listProp.controls[index].patchValue({
        main: true
      });
      for (let i = 0; i < this.checkboxList.length; i++) {
        if (i !== index) {
          this.checkboxList[i] = false;
          this.listProp.controls[i].patchValue({
            main: false
          });
        }
      }
    } else {
      let filter = [];
      if (this.checkboxList) {
        filter = this.checkboxList.filter((value, index1) =>  {
          if (value && index!==index1) {
            return true;
          }
          return false;
        });
      }

      if (filter.length === 0) {
        this.checkboxList[index] = true;
        this.listProp.controls[index].patchValue({
          main: true
        });
      } else {
        this.checkboxList[index] = false;
        this.listProp.controls[index].patchValue({
          main: false
        });
      }
    }
  }

  focusOut(element, i) {
    if (this.listProp.controls[i].value.width <= 0) {
      this.listProp.controls[i].patchValue({
        width: null
      });
    }
    if (this.listProp.controls[i].value.height <= 0) {
      this.listProp.controls[i].patchValue({
        height: null
      });
    }
  }
}
